<template>
  <fieldset class="tla-form-group">
    <label class="tla-form-group__label">{{formattedPurchaseTypeLabel}}</label>
    <div class="tla-form-group__touch-points">
      <touchpoint
        v-for="(item) in purchaseTypeOptions"
        :key="item.touchpointValue"
        :collectionName="'purchaseType'"
        :inputId="item.touchpointValue"
        :inputValue="item.touchpointValue"
        :selected="false"
        :itemText="item.touchpointName"
        :validationScope="validationScope"
        @purchaseType="submitPurchaseType($event)">
        <touchpointText slot="touchpoint" :content="item.touchpointName"></touchpointText>
      </touchpoint>
    </div>
  </fieldset>
</template>

<script lang='ts'>
import {
  Component, Prop, Vue, Watch, Inject
} from 'vue-property-decorator';
import {
  State, Getter, Action, Mutation, namespace
} from 'vuex-class';
import { Validator } from 'vee-validate';
import Touchpoint from '@/models/Touchpoint';
import { tokenService } from '../../services/TokenService';
import FormTouchPointComponent from '../ui/FormTouchPointComponent.vue';
import RadioButtonOptions from '../../models/RadioButtonOptions';
import GenericTouchPointComponent from '../ui/GenericTouchPointComponent.vue';
import PurchaseType from '../../enums/PurchaseType';
import GenericTouchPointTextComponent from '../ui/GenericTouchPointTextComponent.vue';

const EnquiryModule = namespace('enquiryModule');

@Component({
  components: {
  touchpoint: GenericTouchPointComponent,
  touchpointText: GenericTouchPointTextComponent
  }
  })
export default class PurchaseTypeComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: 'What type of purchase are you looking for?' })
  private purchaseTypeLabel!: string;

  @Prop({ default: null })
  public validationScope!: string;

  public get formattedPurchaseTypeLabel() {
    return tokenService.replaceToken(this.purchaseTypeLabel);
  }

  public get purchaseTypeValue(): number {
    return this.$store.getters['financeModule/purchaseTypes'];
  }

  public submitPurchaseType(value: string) {
    const purchaseTypeValue: PurchaseType[] = [parseInt(value, 10)];

    if (purchaseTypeValue[0] !== 0) {
      this.$store.dispatch('financeModule/submitPurchaseTypes', purchaseTypeValue);
    } else {
      this.$store.dispatch('financeModule/submitPurchaseTypes', []);
    }
  }

  public purchaseTypeOptions: Touchpoint[] = [
    new Touchpoint('2', 'PCP'),
    new Touchpoint('3', 'Lease / PCH'),
    new Touchpoint('4', 'Finance / HP'),
    new Touchpoint('5', 'Business / BCH'),
    new Touchpoint('1', 'Outright'),
    new Touchpoint('0', 'Not Sure')
  ];
}
</script>
